import './style.scss'

import React, { Component } from 'react'

import {
    addProductToSubscription,
    activateSubscription,
    gotoSubscriptionInfoOrOverview,
} from 'actions/Subscription'
import Button from 'components/UI/Button'
import SubscriptionStoppedModal from '../SubscriptionStoppedModal'
import WrongRegionModal from '../WrongRegionModal'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Icon from 'components/UI/Icon'
import plus from 'img/plus.svg'
import checkmark from 'img/confirm.svg'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

export class AddToSubscriptionButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showSubscriptionStoppedWarning: false,
            showWrongRegionWarning: false,
        }
    }

    startSubscriptionAndAddProduct = (product, replace = false) => {
        const { gotoSubscriptionPage, activateSubscription } = this.props
        activateSubscription(product, replace)
        this.closeModalStopped()
        gotoSubscriptionPage()
    }

    handleClickAdd(e) {
        const {
            addProductToSubscription,
            noPriorSubscriptions,
            gotoSubscriptionPage,
            isStopped,
            wrongRegion,
        } = this.props

        e.stopPropagation()

        if (wrongRegion) {
            this.setState({ showWrongRegionWarning: true })
            return
        }

        if (isStopped) {
            this.setState({ showSubscriptionStoppedWarning: true })
            return
        }

        addProductToSubscription(this.props.product)

        if (noPriorSubscriptions) {
            gotoSubscriptionPage()
        }
    }

    componentDidMount() {
        // Stub
    }

    closeModal = () => {
        this.setState({
            showSubscriptionStoppedWarning: false,
            showWrongRegionWarning: false,
        })
    }

    renderModalStopped = () => {
        const { showSubscriptionStoppedWarning } = this.state
        if (!showSubscriptionStoppedWarning) return null

        const { subscriptions, products, product, isMobile } = this.props

        return (
            <SubscriptionStoppedModal
                onClose={this.closeModal}
                startSubscriptionAndAddProduct={this.startSubscriptionAndAddProduct}
                subscriptions={subscriptions}
                products={products}
                product={product}
                isMobile={isMobile}
            />
        )
    }

    renderModalWrongRegion = () => {
        if (!this.state.showWrongRegionWarning) return null
        return <WrongRegionModal onClose={this.closeModal} />
    }

    render() {
        const { productInSubscription, explicit, t, style } = this.props

        if (style === 'icon-only') {
            return productInSubscription ? (
                <Button
                    shape="circle"
                    variant="secondary"
                    className="remove-from-subscription-button__icon-only"
                    disabled
                >
                    <Icon svg={checkmark} />
                </Button>
            ) : (
                <Button shape="circle" variant="secondary" onClick={this.handleClickAdd.bind(this)}>
                    <Icon svg={plus} />
                    {this.renderModalWrongRegion()}
                    {this.renderModalStopped()}
                </Button>
            )
        }

        const addClasses = classNames({
            'add-to-subscription-button': true,
            'add-to-subscription-button__explicit': explicit,
        })

        const removeClasses = classNames({
            'remove-from-subscription-button': true,
            'remove-from-subscription-button__explicit': explicit,
        })

        const useNewButtonStyle = style === 'new-style'

        return productInSubscription ? (
            <button
                className={useNewButtonStyle ? 'subscription-button-v2' : removeClasses}
                disabled
            >
                <Icon className="remove-from-subscription-button__icon" svg={checkmark} />
                <span>{t('subscriptionAddToSubscriptionButtonAdded')}</span>
            </button>
        ) : (
            <button
                className={useNewButtonStyle ? 'subscription-button-v2' : addClasses}
                onClick={this.handleClickAdd.bind(this)}
            >
                {!explicit && <span>{t('subscriptionAddToSubscriptionButtonAdd')}</span>}
                {explicit && <span>{t('subscriptionAddToSubscriptionButtonSubscription')}</span>}
                {this.renderModalWrongRegion()}
                {this.renderModalStopped()}
            </button>
        )
    }
}

AddToSubscriptionButton.propTypes = {
    product: PropTypes.object.isRequired,
    style: PropTypes.string,
    noPriorSubscriptions: PropTypes.bool,
    productInSubscription: PropTypes.bool,
    explicit: PropTypes.bool,
    addProductToSubscription: PropTypes.func,
    gotoSubscriptionPage: PropTypes.func,
    activateSubscription: PropTypes.func,
    isStopped: PropTypes.object,
    wrongRegion: PropTypes.bool,
    subscriptions: PropTypes.array,
    products: PropTypes.array,
    isMobile: PropTypes.bool,
    t: PropTypes.func,
}

function mapStateToProps({ subscription, ui, products }, ownProps) {
    const productInSubscription =
        subscription.products.filter((p) => p.id == ownProps.product.id).length > 0
    return {
        isMobile: ui.isMobile,
        noPriorSubscriptions: subscription.products.length === 0,
        productInSubscription,
        isStopped: subscription.stopped,
        wrongRegion: subscription.transportProductStatus === 'OTHER_REGION',
        subscriptions: subscription.products,
        products: products.products,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        addProductToSubscription: (product) => dispatch(addProductToSubscription(product)),
        gotoSubscriptionPage: () => dispatch(gotoSubscriptionInfoOrOverview()),
        activateSubscription: (product, replace) =>
            dispatch(activateSubscription(product, replace)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(AddToSubscriptionButton))
